export default __webpack_public_path__ + "static/media/T344_RoHS.8a0f626b.pdf";